/**
 * @generated SignedSource<<747f12f73c3348e5da6adf53ad0ccc6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAbout_item$data = {
  readonly description: string | null;
  readonly " $fragmentType": "PdpSharedDescriptionAbout_item";
};
export type PdpSharedDescriptionAbout_item$key = {
  readonly " $data"?: PdpSharedDescriptionAbout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAbout_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAbout_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ed3271751e053046a4e75ed8dc8161f3";

export default node;
